module.exports = __webpack_public_path__ + "img/gnu_gallery3.57b010e2.jpg";